import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "text-uppercase font-weight-black" }

import { ref } from "vue";
import { useRouter } from "vue-router";
import { useDisplay } from "vuetify";


import { defineComponent } from "vue";

const __default__ = defineComponent({
  name: "TopNavigation",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const drawer = ref(false);
const routes = useRouter().options.routes.filter(
  (route) => route.meta?.isInMenu
);

const { smAndDown } = useDisplay();

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        app: "",
        color: "primary",
        "clipped-right": "",
        class: "d-flex justify-space-between"
      }, {
        append: _withCtx(() => [
          (_unref(smAndDown))
            ? (_openBlock(), _createBlock(_component_v_app_bar_nav_icon, {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (drawer.value = !drawer.value)),
                "aria-label": _ctx.$t('alt.menuButton')
              }, null, 8, ["aria-label"]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "4",
            md: "2",
            class: "d-flex justify-start"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: { name: 'home' } }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    src: require('@/assets/logo.svg'),
                    width: "120px",
                    alt: _ctx.$t('alt.logo')
                  }, null, 8, ["src", "alt"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (!_unref(smAndDown))
            ? (_openBlock(), _createBlock(_component_v_app_bar_title, {
                key: 0,
                class: "d-flex justify-end"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routes), (rt) => {
                    return (_openBlock(), _createBlock(_component_v_btn, {
                      key: rt.path,
                      to: rt,
                      class: "font-weight-bold rounded-pill",
                      size: "x-large",
                      variant: "text"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("pathName." + rt.name)), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_navigation_drawer, {
        app: "",
        modelValue: drawer.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawer).value = $event)),
        location: "right",
        temporary: "",
        color: "primary-darken-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, { "bg-color": "primary-darken-1" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_group, {
                style: _normalizeStyle({
            'background-color': _ctx.$vuetify.theme.current.colors.primary.darken1,
          })
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(routes), (rt) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      key: rt.path,
                      to: rt,
                      class: "d-flex justify-end"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t("pathName." + rt.name)), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})